<template>
  <v-container>
    <v-layout>
    <v-flex>
      <div>
        <v-tooltip top >
      <v-btn
          class="mr-2 mb-2"
          @click="newParameter"
          color="customPurple"
          dark
          fixed
          bottom
          right
          fab
          slot="activator"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Crear Parámetro</span>
    </v-tooltip>
        <v-layout>
          <v-flex xs12 sm6 offset-sm6>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
      <v-dialog
        v-model="dialog"
        max-width="500px"
        transition="dialog-bottom-transition"
        scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialog = false" @click="cleanData">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Crear nuevo Parámetro</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout>
                <v-flex xs12 sm7 offset-sm1>
                  <v-text-field
                    name="nombre"
                    label="Nombre"
                    id="nombre"
                    :rules="[v => !!v || 'Es requerido', v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                    v-model="parameter.name"
                    required
                    v-on:keyup.enter="saveData"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                    name="codigo"
                    label="Valor"
                    id="value"
                    :rules="[v => !!v || 'El código es requerido', v => (v && v.length <= 200) || 'El valor debe tener menos de 200 caracteres']"
                    required
                    v-model="parameter.value"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-switch
                    label="Inactivo / Activo"
                    v-model="parameter.enabled"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm6 offset-sm4>
                  <div>
                    <v-btn :disabled="!valid"
                           @click="saveData" @click.native="dialog = false" large color="primary">Guardar</v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
    </v-layout>
       <h3 class="primary--text">Lista de Parámetros</h3>
      <v-data-table
        :headers="headers"
        :items="$store.state.parameters"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.value }}</td>
          <td>
            <v-tooltip top >
              <v-btn
              fab dark
              small @click="editItem(props.item)"
              slot="activator"
              color="primary">
              <v-icon dark>edit</v-icon>
            </v-btn>
            <span>Editar</span>
            </v-tooltip>
            <v-tooltip top >
              <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                <v-icon dark>delete</v-icon>
              </v-btn>
            <span>Eliminar</span>
            </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
  </v-container>
</template>
<script>

  import Parameter from "../../model/Paramater";

  export default {
    data () {
      return {
        search: '',
        valid: false,
        requiredField:[v => !!v || 'Es requerido'],
        dialog: false,
        headers: [
          { text: 'Nombre', value: 'name' },
          { text: 'Valor', value: 'value' },
          { text: 'Acciones', value: 'editar' },
        ],
        editedIndex: -1,
        parameter: new Parameter()
      };
    },methods:{
      cleanData(){
        this.$refs.form.reset()
        this.parameter = new Parameter()
        this.valid = false
        this.dialog = false
      },
      newParameter(){
        this.editedIndex = -1
        this.valid = false
        this.dialog = true
        this.$refs.form.reset()
        this.parameter = new Parameter()
      },
      saveData(){
        if(this.$refs.form.validate()){
        if (this.editedIndex > -1) {
          this.$store.dispatch('updateParameter',this.parameter).then(response => {
            this.cleanData()
          }, error => {
            this.$store.state.progress = false
            this.$store.state.dialogError = true
          })
        } else {
          this.$store.dispatch('addParameter',this.parameter).then(response => {
            this.cleanData()
          }, error => {
            this.$store.state.progress = false
            this.$store.state.dialogError = true
          })
        }
          this.dialog= false
      }
      },
      editItem (item) {
        this.editedIndex = this.$store.state.parameters.indexOf(item)
        this.parameter = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = this.$store.state.parameters.indexOf(item)
        this.parameter = Object.assign({}, item)
        confirm('Está seguro de que quiere eliminar el resgitro?') && this.$store.dispatch('deleteParameter',this.parameter.id)
      }
    },
      computed : {
      },
      beforeCreate(){
        this.$store.dispatch('getParameters').then(response => {
        })
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/parameter/Parameter.vue